<!--
 * @Author: 陈乾
 * @Date: 2024-11-07 09:27:54
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 14:27:32
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/views/home.vue
-->
<template>
  <div class="home">
    <div v-if="!isWxWork" class="pageActions">
      <van-button size="small" type="warning" plain @click="handleLogout" style="margin-right: 10px">注销</van-button>
      <van-button size="small" type="primary" plain @click="goToPackageManage">安装包管理</van-button>
      <van-button size="small" type="primary" plain @click="goToPackageListManage">发表记录管理</van-button>
    </div>
    <div class="newData">
      <p class="lastPreview font15">近七天数据变化统计</p>
      <div class="card">
        <div class="card-item flex-y" v-for="(item, index) in cards" :key="index">
          <img :src="item.img" class="card-item-img" alt="" />
          <div class="card-item-info">
            <p class="font14">{{ item.name }}</p>
            <p class="font20 b">{{ item.count }}</p>
          </div>
        </div>
      </div>
      <div class="newDataList">
        <div
          :class="['baseTable', { expand: newDataDetails.expand }]"
          :style="{ '--minH': 0, '--maxH': tableHeight?.maxHeight }"
        >
          <CTable :columns="newDataDetails.columns" :list="newDataDetails.list" @getTableHeight="getTableHeight">
            <template #storeName="{ row }">
              <p class="storeName" :style="{ '--bg': colorMap[row.current_status] }">{{ row.store_name }}</p>
            </template>
            <template #status="{ row }">
              <div v-if="row.previous_status">
                {{ row.previous_status }}
                <span style="transform: rotate(270deg); display: inline-block"
                  ><van-icon name="down" :color="row.current_status === '营业中' ? '#03CE71' : '#FF4E4E'"
                /></span>
                {{ row.current_status }}
              </div>
              <div v-else>
                {{ row.current_status }}
              </div>
            </template>
          </CTable>
        </div>
        <ToggleCollapse
          v-if="newDataDetails.list.length > 0"
          v-model="newDataDetails.expand"
          collapseText="收起详情"
          expandText="展开详情"
        />
      </div>
    </div>
    <div class="modelContainer">
      <div class="model" v-for="(item, index) in business" :key="index">
        <div class="title">
          {{ item.title }} <span class="b">({{ item.list.length }})</span>
        </div>
        <div
          :class="['baseTable', { expand: item.expand }]"
          :style="{ '--minH': item.tableHeight?.minHeight, '--maxH': item.tableHeight?.maxHeight }"
        >
          <CTable :columns="item.columns" :list="item.list" @getTableHeight="value => setTableHeight(value, index)">
          </CTable>
        </div>
        <ToggleCollapse v-if="item.list.length > 3" v-model="item.expand" collapseText="收起" expandText="查看更多" />
      </div>
    </div>
  </div>
</template>

<script>
import CTable from '@/components/table'
import ToggleCollapse from '@/components/toggleCollapse'
export default {
  components: { CTable, ToggleCollapse },
  data() {
    return {
      dashboard: null,
      tableHeight: null,
      lastPreview: '',
      cards: [],
      newDataDetails: {
        expand: false,
        columns: [
          { name: '店铺名称', key: 'storeName' },
          // { name: '店铺城市', key: 'storeCity' },
          { name: '状态', key: 'status', width: '41%', align: 'left' }
        ],
        list: []
      },
      business: [
        {
          tableHeight: null,
          title: '营业中',
          expand: false,
          columns: [
            { name: '店铺名称', key: 'storeName' },
            // { name: '店铺城市', key: 'storeCity' },
            { name: '时间', key: 'time', width: '35%', align: 'left' }
          ],
          list: []
        },
        {
          tableHeight: null,
          title: '待营业',
          expand: false,
          columns: [
            { name: '店铺名称', key: 'storeName' },
            // { name: '店铺城市', key: 'storeCity', width: '40%', align: 'left' },
            { name: '时间', key: 'time', width: '35%', align: 'left' }
          ],
          list: []
        },
        {
          tableHeight: null,
          title: '流失',
          expand: false,
          columns: [
            { name: '店铺名称', key: 'storeName' },
            // { name: '店铺城市', key: 'storeCity' },
            { name: '时间', key: 'time', width: '35%', align: 'left' }
          ],
          list: []
        }
      ],
      colorMap: {
        营业中: '#E23F43',
        新增: '#FFC273',
        流失: '#7E6DAC'
      }
    }
  },
  computed: {
    isWxWork() {
      return navigator.userAgent.toLowerCase().includes('wxwork')
    }
  },
  mounted() {
    this.fetchDashboard()
  },
  methods: {
    async fetchDashboard() {
      try {
        const { data } = await this.$api.storeDashboard()
        if (!data) return
        this.dashboard = data
        this.lastPreview = data.lastPreview || ''
        if (data.cards.length > 0) {
          this.cards = data.cards.map((it, index) => ({
            img:
              index === 0
                ? require('@/assets/images/add.png')
                : index === 1
                ? require('@/assets/images/store.png')
                : require('@/assets/images/data.png'),
            name: it.name || '',
            count: it.count || 0
          }))
          this.newDataDetails.list = data.cards.flatMap(item => item.details)
        }
        if (data.business && Array.isArray(data.business)) {
          // 期望结构与现有 business 一致，否则以原列结构呈现
          this.business = data.business.map(group => ({
            tableHeight: null,
            title: group.title || '',
            expand: false,
            columns: this.business[0].columns,
            list: Array.isArray(group.list) ? group.list : []
          }))
        }
      } catch (e) {
        // 如果 token 缺失或接口异常，提示并停留当前页
        this.$toast('数据获取失败，请检查登录状态')
      }
    },
    async handleLogout() {
      // 调用后端注销接口
      try {
        await this.$api.logout()
      } catch (e) {
        // 即使接口异常也继续清理本地会话
      }
      // 清理本地状态
      this.$commitUserInfo(null)
      localStorage.removeItem('access-token')
      // 跳转到登录页
      this.$router.push('/')
    },
    getTableHeight(value) {
      this.tableHeight = value
    },
    goToPackageManage() {
      this.$router.push('/package')
    },
    goToPackageListManage() {
      this.$router.push('/package/list')
    },
    setTableHeight(value, index) {
      console.log(value, index)
      this.business[index].tableHeight = value
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  color: #2a2e4b;
  min-height: 100vh;
  background: #f6f6f6;
  .pageActions {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px 0 16px;
  }
  .newData {
    background: #fff;
    padding: 18px 16px;
    .card {
      padding: 21px 0 12px;
      border-bottom: 1px solid #eaeaea;
      @include grid(3, 5px, 0);
      .card-item {
        padding: 9px 16px;
        background: #f6f6f6;
        border-radius: 8px;
        &-img {
          width: 28px;
          height: 28px;
          margin-right: 16px;
        }
      }
    }
    .newDataList {
      .dt {
        margin: 8px 0 8px 12px;
      }
    }
  }

  .modelContainer {
    padding: 12px 16px;
    width: 100%;
    .model {
      background: #fff;
      border-radius: 8px;
      padding: 16px 12px 0 12px;
      margin-bottom: 16px;

      .title {
        font-size: 15px;
        margin-bottom: 8px;
      }
    }
  }

  .baseTable {
    overflow: hidden;
    transition: height 0.3s;
    height: var(--minH);
    &.expand {
      height: var(--maxH);
    }
    .storeName {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        background: var(--bg);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: -12px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
